/**
 * @desc 查询列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ReleaseInformationQueryConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.Details>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPublishInfo/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
